import {BaseVatValidator} from './validator';

export {VatDirective} from './directive';
export {VatPipe} from './pipe';

export const VAT_VALIDATORS = [BaseVatValidator];
